module.exports = __webpack_public_path__ + "42cf9b5e1f51c69b9657410da608a381.png";